<template>
  <div
    class="page sign-page"
    :class="
      screenType == 'landscape' ? 'sign-page__landscape' : 'sign-page__portrait'
    "
  >
    <div class="sign-page__hd">
      <h4>请在此手写电子签名</h4>
    </div>
    <div class="sign-page__body">
      <signature ref="signature"></signature>
    </div>
    <div class="sign-page__ft">
      <div class="sign-tools">
        <a href="javascript:;" class="sign-tools__submit" @click="save">保存</a>
        <a href="javascript:;" class="sign-tools__reset" @click="clear">清空</a>
        <a href="javascript:;" class="sign-tools__reset" @click="undo">撤销</a>
      </div>
    </div>
  </div>
</template>
 
<script>
import Signature from "@/components/Signature";
import Weixin from "@/util/weixin.js";

export default {
  components: {
    Signature,
  },
  data() {
    return {
      screenType: null,
    };
  },
  mounted() {
    const me = this;
    me.resize();
    window.addEventListener(
      "onorientationchange" in window ? "orientationchange" : "resize",
      function () {
        me.resize();
        // 重置画布
        window.location.reload();
      }
    );
  },
  methods: {
    save() {
      var me = this;
      if (me.screenType == "portrait" || Weixin.isWeixin() || Weixin.isWxWork()) {
        me.$refs.signature.getHorizontal(function (file) {
          me.doSave(file);
        });
      } else {
        me.doSave(me.$refs.signature.getFile());
      }
    },
    doSave(file) {
      var me = this;
      me.saveFile(file).then(function (fileInfo) {
        if (!fileInfo) {
          return;
        }
        me.saveSign(fileInfo).then(function () {
          me.$route.params.signInfo = {
            signTime: me.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
            signPath: fileInfo.fullPath,
          };
          me.$router.back();
        });
      });
    },
    clear() {
      this.$refs.signature.reset();
    },
    undo() {
      this.$refs.signature.undo();
    },
    resize() {
      var me = this,
        orientation = window.orientation,
        width = window.innerWidth,
        height = window.innerHeight;
      if (orientation == 90 || orientation == -90) {
        //横屏
        me.screenType = "landscape";
      } else if (orientation == 180 || orientation == 0) {
        //竖屏
        me.screenType = "portrait";
      } else if (width >= height) {
        //横屏
        me.screenType = "landscape";
      } else {
        me.screenType = "portrait";
      }
    },
    /**
     * 上传文件
     */
    saveFile(file) {
      var me = this,
        data = new FormData();
      data.append("file", file);
      return me
        .$ajax({
          url: "/api/file/upload",
          method: "POST",
          rawData: data,
        })
        .then(function (res) {
          if (res.success) {
            return res.data;
          } else {
            me.$weui.topTips("保存失败: " + res.message, 3000);
          }
        })
        .catch(function () {
          me.$weui.topTips("保存失败", 3000);
        });
    },
    /**
     * 保存签名信息
     */
    saveSign(fileInfo) {
      var me = this;
      return me
        .$ajax({
          url: "/api/account/sign",
          method: "POST",
          params: {
            path: fileInfo.fullPath,
          },
        })
        .then(function (res) {
          if (res.success) {
            return res.data;
          } else {
            me.$weui.topTips("保存失败: " + res.message, 3000);
          }
        })
        .catch(function () {
          me.$weui.topTips("保存失败", 3000);
        });
    },
  },
};
</script>

<style scoped>
.sign-page {
  overflow: hidden;
}
.sign-page__hd {
  position: absolute;
  display: inline;
  z-index: 1;
  width: 30px;
}
.sign-page__body {
  position: absolute;
  background: #fff;
  height: 100vh;
  width: 100vw;
}
.sign-page__ft {
  position: absolute;
  width: 100vw;
  background-color: #f4f4f4;
  padding: 10px;
  display: flex;
}

.sign-page__portrait .sign-page__hd,
.sign-page__portrait .sign-page__ft {
  -webkit-transform: rotate(90deg);
  -webkit-transform-origin: 0% 0%;

  -moz-transform: rotate(90deg);
  -moz-transform-origin: 0% 0%;

  -ms-transform: rotate(90deg);
  -ms-transform-origin: 0% 0%;

  transform: rotate(90deg);
  transform-origin: 0% 0%;
}

.sign-page__portrait .sign-page__hd {
  top: 10px;
  right: 10px;
}

.sign-page__portrait .sign-page__ft {
  width: 100vh;
  top: 0;
  left: 60px;
}

.sign-page__landscape .sign-page__hd {
  left: 10px;
  top: 10px;
}

.sign-page__landscape .sign-page__ft {
  left: 0;
  bottom: 0;
}

.sign-page__ft .sign-tools {
  flex: 1;
  display: inline-block;
  text-align: center;
}

.sign-tools > a {
  font-weight: 700;
  font-size: 17px;
  margin-right: 20px;
  padding: 8px 24px;
  border-radius: 4px;
  display: inline-block;
}
.sign-tools__reset {
  background: #fff;
  color: #666;
}
.sign-tools__submit {
  background-color: var(--weui-BRAND);
  color: #fff;
}
</style>